import React from 'react';

import { InputRow } from '../../../../helpers/uiComponents/InputRow';
import AccordianTitle from '../../../../helpers/uiComponents/Accordian';
import { addUserAccount, getCustomerUserAccounts, getUserByEmail, removeUserAccount, sendForgotPassEmail } from '../../../../data/serviceSso';
import { addClient } from '../../../../data/serviceClients';
import { hideMessage, hidePopup, showMessage, showPopup } from '../../../../helpers/uiFunctions/uiActions';

class InsightManager extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
			settings: [],
			users: [],
		}
		this.addUser = this.addUser.bind(this);
	}

	componentDidMount() {
		this.setState({
			settings: this.props.currentClient.portal,
		});
		getCustomerUserAccounts(this.props.currentClient.clientCode).then(data => {
			this.setState({
				users: data.result,
			});
		})
	}

	addUser() {
		showMessage("Adding User...");
		var email = document.getElementById("new-email").value;
		email = email.toLowerCase();
		var clientCode = this.props.currentClient.clientCode;
		var status = this.props.currentClient.status;
		var fName = document.getElementById("new-fName").value;
		var lName = document.getElementById("new-lName").value;
		var newState = this.state.users;
		console.log(newState);
		
		if(this.validateEmail(email)) {
			addUserAccount(clientCode, email, fName, lName, status).then(response => {
				newState.push({
					"clientCode": clientCode,
					"email": email,
					"firstName": fName,
					"lastName": lName,
					"userName": email,
				});
				this.setState({ users: newState });
				hideMessage(response.success);
				document.getElementById("new-email").value = "";
				document.getElementById("new-fName").value = "";
				document.getElementById("new-lName").value = "";
				if (response.success) {
					hidePopup("addUser");
				}
			});
		} else {
			showMessage("You have entered an invalid email address!");
			hideMessage();
		}
	}

	sendReset(email) {
		var status = this.props.currentClient.status;
		sendForgotPassEmail(email, status).then(() => {
			showMessage("An email has been sent to "+email+" that contains a link to reset their password.");
			hideMessage();
		});
	}

	handleSave(metric) {
		var body = this.props.currentClient;
		var val = document.querySelector('#all-portals input[name="'+metric+'"]').checked;
		body.portal[metric] = val;
		if(val) {
			showMessage("Adding Metric...")
		} else {
			showMessage("Removing Metric...")
		}
		addClient(body).then(data => {
			hideMessage(data.success);
			if (data.success) {
				this.setState({settings: data.result.portal});
				var getClient = this.props.getClient;
				getClient(this.props.currentClient.clientCode);
			}
		});
	}

	deleteUser(email) {
		showMessage("Deleting "+email+"...")
		getUserByEmail(email).then(user => {
			console.log(user);
			removeUserAccount(email, this.props.currentClient.clientCode, user).then(response => {
				hideMessage(response.success);
				if (response.success) {
					var newState = this.state.users;
					newState = newState.filter(user => {return user.email !== email});
					this.setState({users: newState});
				}
			});
		});
	}

	validateEmail(mail) {
		// console.log(mail)
		var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
		if(mail.match(mailformat)) {
			return true;
		} else {
			return false;
		}
	}

	render () {
		const { settings, users } = this.state;
		return (
			<div className="input-group">
				<AccordianTitle title={"Insight Management"} />
				<div className="accordian-body">
					<div>
						{(users) && (
							<React.Fragment>
								<section className="section">
									<form className="form popup-form" id="addUser" style={{display: 'none'}}>
										<i className="fas fa-times icon" onClick={() => hidePopup("addUser")} style={{float: 'right'}}></i>
										<h3>Add New Insight User</h3>
										<p className="client-error"></p>
				
										<p><strong><em>* required</em></strong></p>
										<InputRow label="* Email Address" placeholder="New User Email Address" type="text" id="new-email" name="email" />
										<InputRow label="* First Name" placeholder="First Name" type="text" id="new-fName" name="fName" />
										<InputRow label="* Last Name" placeholder="Last Name" type="text" id="new-lName" name="lName" />
				
										<input onClick={this.addUser} type="button" className="button is-info" value="Add User" />
									</form>
								</section>
								<h3>Active User Accounts</h3>
								<button onClick={() => showPopup("addUser")}>Add New User +</button>
								<div className="table">
									<div className="table-heading">
										<div className="group-labels">
											<div>User Email</div>
											<div>Name</div>
											<div>Reset Password</div>
											<div>Delete</div>
										</div>
									</div>
									<div className="table-body">
										{(users.map(user =>
											<li key={user.email}>
												<div>{user.email}</div>
												<div>{user.firstName} {user.lastName}</div>
												<div><button className="button" onClick={() => this.sendReset(user.email)}>send reset email</button></div>
												<div><button className="button" onClick={() => this.deleteUser(user.email)}><i className="far fa-trash-alt"></i></button></div>
											</li>
										))}
									</div>
								</div>
							</React.Fragment>
						)}
					</div>
					<div>
						{(settings) && (
							<React.Fragment>
								<h3>Metric Visibilty Settings</h3>
								<div>*These settings only hide/show Metrics for Clients. AMs will always be able to see all Metrics</div>
								<div id="all-portals">
									<InputRow label="Lead Tracking, By Channel, By Form" type="checkbox" value={settings.leads} property="leads" onChange={() => this.handleSave("leads")} />
									<InputRow label="Call Tracking" type="checkbox" value={settings.calls} property="calls" onChange={() => this.handleSave("calls")} />
									<InputRow label="Samples" type="checkbox" value={settings.samples} property="samples" onChange={() => this.handleSave("samples")} />
									<InputRow label="Emails Sent" type="checkbox" value={settings.emails} property="emails" onChange={() => this.handleSave("emails")} />
									{/* <InputRow label="Keyword Analytics" type="checkbox" value={settings.getStats} property="getStats" onChange={() => this.handleSave("getStats")} /> */}
									<InputRow label="Google Analytics" type="checkbox" value={settings.analytics} property="analytics" onChange={() => this.handleSave("analytics")} />
									<InputRow label="Google Adwords" type="checkbox" value={settings.adwords} property="adwords" onChange={() => this.handleSave("adwords")} />
									<InputRow label="Google My Business" type="checkbox" value={settings.googleMyBusiness} property="googleMyBusiness" onChange={() => this.handleSave("googleMyBusiness")} />
									<InputRow label="Google Ratings" type="checkbox" value={settings.googleRatings} property="googleRatings" onChange={() => this.handleSave("googleRatings")} />
									<InputRow label="Search Console" type="checkbox" value={settings.searchConsole} property="searchConsole" onChange={() => this.handleSave("searchConsole")} />
									<InputRow label="Facebook" type="checkbox" value={settings.facebook} property="facebook" onChange={() => this.handleSave("facebook")} />
									<InputRow label="Roomvo" type="checkbox" value={settings.roomvo} property="roomvo" onChange={() => this.handleSave("roomvo")} />
									<InputRow label="Rugs Shop Orders" type="checkbox" value={settings.rugsShop} property="rugsShop" onChange={() => this.handleSave("rugsShop")} />
									<InputRow label="Simpli.Fi API" type="checkbox" value={settings.simplifi} property="simplifi" onChange={() => this.handleSave("simplifi")} />
								</div>
							</React.Fragment>
						)}
					</div>
				</div>
			</div>
		)
	}
}
export default InsightManager;


// WEBPACK FOOTER //
// ./src/component_client/components/ClientProfile/ProfileComponents/InsightManager.js